// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

export function pushWWTFormSubmitEvent(wwtResult: string, town: string) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "formSubmitWWT_WWW",
      wwt_result: wwtResult,
      town,
    });
  }
}
